import { Component } from '@angular/core';

@Component({
  selector: 'smart-info-empresa',
  templateUrl: './info-empresa.component.html',
  styleUrls: ['./info-empresa.component.scss']
})
export class InfoEmpresaComponent{
}
